import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, Input, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes/component/devices.class';
import { Router } from '@angular/router';
import { NewsService } from '@app/modules/news-modules/news.service';
import { IBlogPostNewsDetail } from '@app/modules/news-modules/news.models';
import { AppStaticURL } from '@app/app.settings';
import { RoutingConfig } from '@app/routing/routing.config';
declare var $;

export enum MainBannersViewTypes {
  NewsGallery,      // 0
  VerticalBanner,   // 1
}

@Component({
  selector: 'shared-main-banners',
  templateUrl: 'main-banners.component.html',
  styleUrls: [`./main-banners.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class MainBannersComponent extends DevicesClass implements OnInit {
  public Routing = RoutingConfig;
  public MBTypes = MainBannersViewTypes;
  public StaticURL = AppStaticURL;

  public MainBannerNewsListData: Array<IBlogPostNewsDetail> = [];
  public MainBannerNewsLoading: boolean = true;
  public MainBannerNewsThumbnailError: boolean = false;

  public VerticalBannerNewsListData: Array<IBlogPostNewsDetail> = [];
  public VerticalBannerNewsLoading: boolean = true;
  public VerticalBannerNewsThumbnailError: boolean = false;

  @Input() MainBannersView: MainBannersViewTypes;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    private router: Router,
    private newsService: NewsService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.MainBannersView === this.MBTypes.NewsGallery) {
      this.newsService.getAllNews(3).subscribe(
        response => {
          this.MainBannerNewsLoading = false;
          this.MainBannerNewsListData.push(...response.items);
          this.cdr.markForCheck();

          /**
           * Hook of Slick plugin init.
           */
          setTimeout(() => this.onMainNewsGalleryFn(), 100)
        }
      );
    }

    if (this.MainBannersView === this.MBTypes.VerticalBanner) {
      this.newsService.getAllNews(5).subscribe(
        response => {
          response.items.splice(0, 3);

          this.VerticalBannerNewsLoading = false;
          this.VerticalBannerNewsListData.push(...response.items);
          this.cdr.markForCheck();
        }
      )
    }
  }

  onTextHeadingSplit(heading: string): string {
    const splitHeading = heading.split('').filter((item, i) => i < 80).join('');

    return heading.split('').length >= 80 ? splitHeading + '...' : heading;
  }

  onMainNewsGalleryFn(): void {
    if (typeof $ === 'function') {
      $('.main-banners__slide').slick({
        autoplay: true,
        autoplaySpeed: 8000,
        infinite: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.main-banners__gallery-nav-prev'),
        nextArrow: $('.main-banners__gallery-nav-next'),
      });
    }
  }
}
